import React, { Fragment } from "react";

import {
  Caminho,
  TextoCaminho,
  IconeCaminho,
  ContainerCaminhoAtalhos,
} from "./styles";
import { useNavigate } from "react-router-dom";

const Breadcrumb = ({
  caminho = [
    { titulo: "exemplo" },
    { titulo: "exemplo 2", url: "/fidelidade/cashback" },
  ],
}) => {

  const navigate = useNavigate();

  const paginas = () => {
    return caminho.map((item, index) => {
      return (
        <Fragment key={item.titulo + "Breadcrumb" + index}>
          {item.url != undefined ? (
            <TextoCaminho
              style={{ cursor: "pointer" }}
              onClick={() => navigate(item.url)}
            >
              {item.titulo}
            </TextoCaminho>
          ) : (
            <TextoCaminho>{item.titulo}</TextoCaminho>
          )}
          {caminho.length - 1 > index && <IconeCaminho />}
        </Fragment>
      );
    });
  };

  return (
    <ContainerCaminhoAtalhos>
      <Caminho>{paginas()}</Caminho>
    </ContainerCaminhoAtalhos>
  );
};

export default Breadcrumb;
